// extracted by mini-css-extract-plugin
export default {"otp-input":"OtpInput_otp-input__3Ei++"};